var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n  Andons stoppés ce jour / moyenne quotidienne"),_c('br'),_vm._v(" "),_c('p',{staticClass:"andoncount"},[_c('span',{class:[_vm.serieAndons[0].data[4] - _vm.serieAndons[1].data[4] >= 0 ? "good": "bad"]},[_vm._v(_vm._s(_vm.serieAndons[0].data[4]))]),_vm._v(" / "),_c('span',[_vm._v(_vm._s(_vm.serieAndons[1].data[4]))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cf930660","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/andon/stats.vue
// module id = null
// module chunks = 